<template>
  <v-container
    class="bg bg--gray"
    fill-height
    fluid
  >
    <LoginBox>
      <h1 class="login__title">{{ $t(`${namespace}.title`) }}</h1>
      <p v-html="$t(`${namespace}.text`)" class="mb-4" />

      <Button
        color="secondary"
        gradient
        block
        large
        @click="handleRedirectToPlatform"
      >
        {{
          loggedIn
            ? $t(`${namespace}.goToInvoiceHistory`)
            : $t(`${namespace}.accessToPlatform`)
        }}
      </Button>
    </LoginBox>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ExpiredLinkPage',
  computed: {
    ...mapState({
      loggedIn: ({ session }) => session.status.loggedIn
    })
  },
  data () {
    return {
      namespace: 'Views.ExpiredLinkPage'
    }
  },
  methods: {
    handleRedirectToPlatform () {
      const name = this.loggedIn ? 'InvoiceHistory' : 'Login'
      this.$router.push({ name })
    }
  }
}
</script>
